import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertNetworkToToken',
  standalone: true,
})
export class ConvertNetworkToTokenPipe implements PipeTransform {
  transform(network: string): string {
    if (!network) {
      return network;
    }
    switch (network) {
      case 'TRX':
        return 'TRC-20'
      case 'TRON':
        return 'TRC-20'
      case 'ETH':
        return 'ERC-20'
      case 'BSC':
        return 'BEP-20'
      default:
        return network
    }
  }
}
